import React from 'react'
import { Box, Button, Tooltip } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'

import { secondaryButtonSx } from '@components'
import { dsColorNew } from '@palette'

/**
 * "Download raw CSV" button for data-validation purposes.
 *
 * Streams the rows that feed the active widget — every column of the
 * underlying fact table plus the denormalised joins. Capped server-side
 * to a 7-day window so we never ship a 30M-row dump by accident; the
 * button is disabled client-side when the active window exceeds the
 * cap so the user notices before clicking.
 *
 *   <DownloadCsvButton href="/api/my-business/revenue/download?from=...&to=..."
 *                      from="2026-06-01" to="2026-06-07"
 *                      label="Bookings CSV" />
 */
const MAX_WINDOW_DAYS = 7

export function isWindowDownloadable(from, to) {
	if (!from || !to) return false
	const a = new Date(`${from}T00:00:00Z`)
	const b = new Date(`${to}T00:00:00Z`)
	if (Number.isNaN(a) || Number.isNaN(b) || b < a) return false
	const days = Math.round((b - a) / 86400000) + 1
	return days <= MAX_WINDOW_DAYS
}

export default function DownloadCsvButton({ href, from, to, label = 'Raw CSV', size = 'small', sx = {} }) {
	const enabled = isWindowDownloadable(from, to)
	const tooltip = enabled
		? `Streams every column of the source table (last ${MAX_WINDOW_DAYS} days max).`
		: `Raw downloads are capped at ${MAX_WINDOW_DAYS} days. Narrow the date range first.`
	return (
		<Tooltip title={tooltip} arrow>
			<Box component="span" sx={{ display: 'inline-flex' }}>
				<Button
					size={size}
					variant="outlined"
					startIcon={<IconSeeker icon="file-arrow-down" sx={{ fontSize: 14 }}/>}
					sx={{ ...secondaryButtonSx, '&.Mui-disabled': { borderColor: dsColorNew.grayBorder }, ...sx }}
					disabled={!enabled}
					component={enabled ? 'a' : 'button'}
					href={enabled ? href : undefined}>
					{label}
				</Button>
			</Box>
		</Tooltip>
	)
}
